import { useState } from 'react';
import { useAuth } from '@/hooks/useAuth';
import { InvoicesB2cPage, InvoicesB2bPage } from './InvoicesPage';

export function InvoicesUnifiedPage() {
  const { user } = useAuth();
  const serviceType = user?.kind === 'merchant' ? user.serviceType : 'BOTH';
  const showB2c = serviceType !== 'B2B';
  const showB2b = serviceType !== 'B2C';
  const defaultTab: 'B2C' | 'B2B' = showB2c ? 'B2C' : 'B2B';
  const [tab, setTab] = useState<'B2C' | 'B2B'>(defaultTab);
  const availableTabs = ([showB2c ? 'B2C' : null, showB2b ? 'B2B' : null].filter(Boolean) as Array<'B2C' | 'B2B'>);
  return (
    <div>
      <div className="px-6 pt-6">
        <div className="flex items-center gap-1 bg-slate-100 rounded-lg p-1 mb-2 w-fit">
          {availableTabs.map((t) => (
            <button key={t} onClick={() => setTab(t)}
              className={`px-5 py-1.5 text-sm rounded-md transition ${tab === t ? 'bg-white shadow-sm text-emerald-700 font-medium' : 'text-slate-600 hover:text-slate-900'}`}>
              Invoices {t}
            </button>
          ))}
        </div>
      </div>
      {tab === 'B2C' && showB2c ? <InvoicesB2cPage /> : null}
      {tab === 'B2B' && showB2b ? <InvoicesB2bPage /> : null}
    </div>
  );
}
